export default __webpack_public_path__ + "static/media/Fervid Emotions.6a0b3048.png";